
angular.module("dyb.util.widgets", ['classy', 'classy-on', 'dybTags']);
